(function () {
  if (window.RLQuickAdd) return;

  function getRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function findCartTarget() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) return { el: drawer, id: drawer.getAttribute('data-section') || drawer.id || 'cart-drawer' };
    var notif = document.querySelector('cart-notification');
    if (notif) return { el: notif, id: notif.getAttribute('data-section') || notif.id || 'cart-notification' };
    return null;
  }

  function submit(form) {
    var btn = form.querySelector('[data-rl-atc-button]');
    if (btn && btn.disabled) return;

    var labelEl = form.querySelector('.rl-atc__label');
    var originalLabel = labelEl ? labelEl.textContent : '';

    var fd = new FormData(form);
    var target = findCartTarget();
    if (target) {
      fd.append('sections', target.id);
      fd.append('sections_url', window.location.pathname);
    }

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    }

    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status && res.data.status >= 400)) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'cart_error');
        }
        if (target && res.data && res.data.sections && res.data.sections[target.id]) {
          try {
            var parser = new DOMParser();
            var html = parser.parseFromString(res.data.sections[target.id], 'text/html');
            var tagName = target.el.tagName.toLowerCase();
            var newEl = html.querySelector(tagName);
            if (newEl && target.el.parentNode) {
              target.el.replaceWith(newEl);
            }
          } catch (_e) {}
        }
        var live = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (live && typeof live.open === 'function') {
          live.open();
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: res.data }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: res.data }));

        if (labelEl) labelEl.textContent = '✓';
        setTimeout(function () {
          if (labelEl) labelEl.textContent = originalLabel;
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.classList.remove('is-loading');
          }
        }, 1400);
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        }
        window.location.href = getRoot() + 'cart';
      });
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-rl-atc-form]').forEach(function (form) {
      if (form.dataset.rlAtcBound === '1') return;
      form.dataset.rlAtcBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submit(form);
      });
      form.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  }

  window.RLQuickAdd = { submit: submit, bind: bind };

  function boot() { bind(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { if (e.target) bind(e.target); });
})();
